export enum WorkManagerEventStatusEnum {
    Employee, // работник
    Manager, // менеджер
    Approved, // согласовано
    Review, // на проверке
    Completed, // выполнено
    ExcusedAbsence, // не выход по уважительной причине
    UnexcusedAbsence, // не выход по неуважительной причине (прогул)
    DoNotDisturb, //выходной
}
